import { createFileRoute } from '@tanstack/react-router'

import AdminProvinsiPage from '@/components/pages/backoffice/_user/_provinsi/containers/ AdminProvinsiPage'
export const Route = createFileRoute('/_backoffice/user/provinsi/')({
  component: AdminProvinsiPage
})
